import http from "@/common/http.service";
const ROOT_URL = "segment/lists/";
const DELETE_URL = "segment/delete/";
const REFRESH_URL = "segment/updateActiveCount";
const LIST_URL = "segment/getLists";
const SAVE_URL = "segment/save/";
const AUTOCOMPLETE_URL = "segmnet/autocomplete";
const EDITSEGMENT_URL = "segment/getsegmentWithid";
const EMAILLIST_URL = "segment/emails";
const SEGMENTDATA_URL = "segment/data";
const CUSTOM_PROPERTY = "segment/getCustomproperty";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.list_data.report_data,
        total: response.data.listcount,
      };
      cb(data);
    });
  },
  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
  refresh(id) {
    return http.post(REFRESH_URL, { id: id });
  },
  getLists(cb) {
    http.get(LIST_URL).then(function (response) {
      cb(response.data);
    });
  },
  saveSegment(params) {
    return http.post(SAVE_URL, params);
  },
  getCampaigns(params, cb) {
    http.post(AUTOCOMPLETE_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  editSegment(params) {
    return http.post(EDITSEGMENT_URL, params);
  },
  getSubscribersFromList(params, cb) {
    http.post(EMAILLIST_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  getListData(params, cb) {
    http.post(SEGMENTDATA_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  fetchCustomProperty(cb) {
    return http.post(CUSTOM_PROPERTY).then(function (response) {
      var data = {
        data: response.data.custom_property,
        limit: response.data.custom_property_limit,
        allowMailboxProvider: response.data.allowMailboxProvider,
      };
      cb(data);
    });
  },
};
